var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"recipe-preparation"},[(_vm.displaySteps.length)?_c('ol',{staticClass:"recipe-preparation__steps"},_vm._l((_vm.displaySteps),function(step,index){return _c('li',{key:index},[_vm._v(_vm._s(step))])}),0):_c('p',{staticClass:"recipe-preparation__source"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }